var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTraction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15",
    transform: "translate(-366 -663)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_38",
    "data-name": "Rect\\xE1ngulo 38",
    width: 18,
    height: 18,
    transform: "translate(366 663)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "car-manual-transmission",
    d: "M6.591,3.944H4V2H6.591V3.944M4,14.957H6.591V13.014H4v1.944M10.479,2H7.887V3.944h2.591V2M7.887,14.957h2.591V13.014H7.887v1.944M11.774,2V3.944h2.591V2H11.774m.648,5.831H9.831V5.239h-1.3V7.831H5.944V5.239h-1.3v6.479h1.3V9.127H8.535v2.591h1.3V9.127h3.887V5.239h-1.3Z",
    transform: "translate(366 664)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraction);
export default __webpack_public_path__ + "static/media/traction.055bdb095105d3a62502866a55dbac48.svg";
export { ForwardRef as ReactComponent };